import { create } from 'zustand';
import { StatusConfigStoreInterface } from './types';
import { StatusConfig } from '../services/statusConfig/types';

const getStatusMapping = (approvalStatus: StatusConfig[]) => {
  const mappingObj = approvalStatus.reduce((accumulator, value) => {
    return {
      ...accumulator,
      [value.status]: {
        id: value.status,
        label: value.description,
        backgroundColor: value.backgroundColor,
        textColor: value.textColor,
      },
    };
  }, {});
  return mappingObj;
};

const StatusConfigStore = create<StatusConfigStoreInterface>()((set) => {
  return {
    approvalStatus: [],
    approvalStatusMapping: {},
    setStatusConfig: ({ approvalStatus }) => {
      set((state) => {
        return {
          ...state,
          approvalStatus,
          approvalStatusMapping: getStatusMapping(approvalStatus),
        };
      });
    },
  };
});

export default StatusConfigStore;
